module.exports = __webpack_public_path__ + "media/assets/img/locales/en_locale_flag-1dcb58cb667c8dee4b375001d96f29e9.png";